import io from 'socket.io-client'

// Use window.location.origin to automatically use correct domain
export const socket = io(window.location.origin)

// Gắn JWT vào socket chung (helpdesk + chuông thông báo — plan 261023-2005 phase 02). Idempotent mỗi lần đăng nhập.
let authedToken = null
export function ensureSocketAuthed() {
  const token = localStorage.getItem('accessToken')
  if (!token || token === authedToken) return
  socket.auth = { token }
  if (socket.connected) socket.disconnect()
  socket.connect()
  authedToken = token
}

/** Gọi khi logout — lần login sau handshake lại bằng JWT mới. */
export function resetSocketAuth() {
  authedToken = null
  if (socket.auth) socket.auth = {}
  if (socket.connected) socket.disconnect()
}
